module.exports = __webpack_public_path__ + "images/emoji/hatching_chick.a54d393bda00b68931c7.png";